module.exports = {
    language: 'language',
    direction: 'direction',
    isLoading: 'isLoading',
    isLoggedIn: 'isLoggedIn',
    showLogin: 'showLogin',
    showSignup: 'showSignup',
    showResetPassword: 'showResetPassword',
    user: 'user',
    cookie: 'cookie',
    token: 'token',
}